/*
saikrishna 11/03/2022 2698592321 changed the paginationOptions
akhila 11/03/2022 2698823069  TablePagination bugFix
 */
import React, {createRef, useEffect, useState, useContext} from 'react';
// import MaterialTable from "material-table";
import {tableIcons} from '../../../../components/TableIcons';
import {Button, TablePagination} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DialogBox from '../../../../components/DialogBox';
import ClientContactForm from './ClientContactForm';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../components/CustomSnackBar';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation} from 'react-router';
import {httpPaginationPost} from '../../../../util/Rest';
import {resetMessage} from '../../../../redux/reducers/client-maintainance/ClientContact';
import {CLIENT_MAINTENANCE} from '../../../../constants/MicroServiceConstants';
import {fetchDropDowns} from '../../../../redux/reducers/client-maintainance/ClientContact';
import DeleteClient from './DeleteClient';
import formatPhoneNumber from '../../../../util/PhoneFormat';
import {defaultRows, tablePageRows} from '../../../../constants/ReusableConstants';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

const ClientContactInfoTable = () => {
  const [dialog, setDialog] = useState(false);
  // const [deleteDialog, setDeleteDialog] = useState(false);
  const deleteDialog = false;
  const [rowData, setRowData] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const tableRef = createRef();
  const [arrayLast, setArrayLast] = useState(false);
  const location = useLocation();
  const clientNumber = location?.state?.clientNumber;
  const dispatch = useDispatch();
  const [rows, setRows] = useState(defaultRows);

  const {errorMsg, successMsg, clientContactStatus} = useSelector(
    ({clientContact}) => clientContact,
  );
  const handleEditRow = (rowData) => {
    setIsEditMode(true);
    setRowData(rowData);
  };
  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
    }
  }, [errorMsg, successMsg]);
  useEffect(() => {
    dispatch(fetchDropDowns());
  }, []);
  const columns = [
    {
      title: 'Contact Type',
      field: 'contactType',
    },
    {
      title: 'Name',
      field: 'contactName',
    },
    {
      title: 'E-mail Address',
      field: 'contactEmailAddress',
    },
    {
      title: 'Phone Number',
      field: 'contactPhoneNumber',
      render: (rowData) => formatPhoneNumber(rowData.contactPhoneNumber),
    },
    {
      title: 'Fax Number',
      field: 'contactFaxNumber',
      render: (rowData) => formatPhoneNumber(rowData.contactFaxNumber),
    },
  ];
  const handleDeleteClose = () => {
    setIsDelete(false);
    setRowData({});
  };
  useEffect(() => {
    if (tableRef.current && clientContactStatus === 200) {
      tableRef.current.onQueryChange();
      handleDeleteClose();
    }
  }, [clientContactStatus]);

  const handleClose = () => {
    if (isEditMode) {
      setIsEditMode(false);
      setRowData({});
    } else {
      setDialog(false);
    }
  };
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [isDelete, setIsDelete] = useState(false);
  const {roleData} = useSelector(({role}) => role);
  const disabledByRole = roleData?.window?.['Client Maintenance']?.CCI;
  return (
    <>
      <div className="custom-table">
        <DialogBox
          maxWidth={'md'}
          fullWidth
          open={dialog || isEditMode}
          dialogClose={handleClose}
          title={
            (dialog && 'Add Client Contact Information') ||
            (isEditMode && 'Edit Client Contact Information ')
          }
        >
          <ClientContactForm handleClose={handleClose} isEditMode={isEditMode} rowData={rowData} />
        </DialogBox>
        <DialogBox open={deleteDialog} dialogClose={handleClose}></DialogBox>
        <div className="custom-table global-field-table">
          <GuiTable
            icons={tableIcons}
            title="Client Contact Information"
            columns={columns}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `${CLIENT_MAINTENANCE}/find/all/contact`;
                const bodyObj = {
                  clientNumber: clientNumber,
                  limit: query.pageSize ? query.pageSize : null,
                  page:
                  arrayLast && query.page >= 1 ?
                    query.page :
                    arrayLast ?
                      (query.page <= 1 && query.page + 1) || query.page - 1 :
                      query.page + 1,
                  orderDirection: query.orderDirection,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  search: query.search.trim(),
                };
                if (!clientNumber) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 5,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        resolve({
                          data: response.data.response.resultObjects ?
                            response.data.response.resultObjects :
                            [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(response.data.response.resultObjects.length === 1);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response?.message,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              ),
            }}
            options={{
              pageSize: rows,
              pageSizeOptions: tablePageRows,
              sorting: true,
              search: true,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            onSelectionChange={(rows) => rows}
            actions={[
              {
                icon: () => <EditOutlinedIcon/>,
                tooltip: 'Edit',
                disabled: !disabledByRole?.edit,
                onClick: (event, rowData) => handleEditRow(rowData),
              },
              {
                icon: () => <DeleteOutlineOutlinedIcon/>,
                tooltip: 'Delete',
                disabled: !disabledByRole?.delete,
                onClick: (event, rowData) => {
                  setRowData(rowData);
                  setIsDelete(true);
                },
              },
              {
                icon: () => (
                  <div>
                    <Button
                      variant="outline"
                      className={`search-btn ${classes.buttonRoot}`}
                      disabled={!disabledByRole?.add}
                    >
                      <AddIcon /> Add
                    </Button>
                  </div>
                ),
                disabled: !disabledByRole?.add,
                isFreeAction: true,
                onClick: () => setDialog(true),
              },
            ]}
          />
        </div>
        <DialogBox title="Delete Client Contact" open={isDelete} dialogClose={handleDeleteClose}>
          <DeleteClient handleDeleteClose={handleDeleteClose} rowData={rowData} />
        </DialogBox>
      </div>
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default ClientContactInfoTable;
